module.exports = __webpack_public_path__ + "media/images/icons/export-1e34e2e0a3cd3283f38fad22936faa78.svg";